import { Instance } from 'mobx-state-tree';
import { RouteTimelineConstraintDtoModelBase } from './RouteTimelineConstraintDtoModel.base';

/* The TypeScript type of an instance of RouteTimelineConstraintDtoModel */
export interface RouteTimelineConstraintDtoModelType extends Instance<typeof RouteTimelineConstraintDtoModel.Type> {}

/* A graphql query fragment builders for RouteTimelineConstraintDtoModel */
export { selectFromRouteTimelineConstraintDto, routeTimelineConstraintDtoModelPrimitives, RouteTimelineConstraintDtoModelSelector } from './RouteTimelineConstraintDtoModel.base';

/**
 * RouteTimelineConstraintDtoModel
 */
export const RouteTimelineConstraintDtoModel = RouteTimelineConstraintDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
